import { rowColumn } from "../../../components/table/Table";
import { assignStatusPrimaryOptions, assignStatusSecondaryOptions } from "../../formObjects/application/assignStatusForm";
import { getFilterOptions } from "../../CommonFunctions";
export const applicationsAllListTable = (currPath: string, assessors: any): rowColumn[] => [
  {
    label: "KIS ID",
    column: "id",
    type: "string",
    allowSort: true,
    sortOn: "Id",
  },
  {
    label: "First Name",
    column: "firstName",
    type: "string",
    allowSort: true,
    sortOn: "FirstName",
    isFilter: true,
    filterType: "search",
  },
  {
    label: "Last Name",
    column: "lastName",
    type: "string",
    allowSort: true,
    sortOn: "LastName",
    isFilter: true,
    filterType: "search",
  },
  {
    label: "Kindergarten",
    column: "fundedKinderName",
    type: "string",
    allowSort: true,
    sortOn: "FundedKinderName",
    body: (rowData) => {
      return <p className="m-0">{rowData.fundedKinderName === "Other" ? rowData.kindergartenNameOther : rowData.fundedKinderName}</p>;
    },
    isFilter: true,
    filterType: "search",
    filterKeyColumns: ["fundedKinderName", "kindergartenNameOther"],
  },
  {
    label: "Assigned Assessor",
    column: "assignedAssessorName",
    type: "string",
    allowSort: true,
    sortOn: "AssignedAssessorName",
    isFilter: true,
    filterType: "multiselect",
    filterElements: assessors,
  },
  {
    label: "Status",
    column: "statusComputed",
    type: "string",
    allowSort: true,
    sortOn: "StatusComputed",
    isFilter: true,
    filterType: "multiselect",
    filterElements: getFilterOptions(assignStatusPrimaryOptions, assignStatusSecondaryOptions),
  },
  {
    label: "Date Submitted",
    column: "dateSubmitted",
    type: "date",
    allowSort: true,
    sortOn: "DateSubmitted",
  },
  {
    label: "Actions",
    body: (rowData) => <a href={`${currPath}/${rowData.discriminator}/${rowData.id}`}>View Details</a>,
  },
];
